import { isWebPlatform } from './platform.js';

// Two broken cases, opposite directions:
//   - Telegram Desktop's webview returns false from window.confirm() regardless
//     of which button the user clicks, so there we must use showConfirm.
//   - On TG Web (weba/webk), the miniapp window itself counts as a popup and
//     showConfirm silently fails to display; window.confirm works there.
// Pick per-platform.
export function initConfirm() {
	document.body.addEventListener('htmx:confirm', function(e) {
		var q = e.detail.question;
		if (!q) return;
		e.preventDefault();
		if (!isWebPlatform() && window.Telegram?.WebApp?.showConfirm) {
			Telegram.WebApp.showConfirm(q, function(ok) {
				if (ok) e.detail.issueRequest(true);
			});
		} else {
			if (window.confirm(q)) e.detail.issueRequest(true);
		}
	});
}